module.exports = "https://www.gc-qa.gnp.com.mx/faeb86652fc103d9bbe60e3b21de769d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/add_mini.svg
// module id = 1795
// module chunks = 0